import React from "react";

type InfoBannerProps = {
    title: string;
    description: string;
    icon?: React.ReactNode;
};

const InfoBanner: React.FC<InfoBannerProps> = ({ title, description, icon }) => {
    return (
        <div className="py-2 border-main-border border-b flex bg-white items-center justify-between">
            <div className="flex gap-2 flex-1 items-center justify-between">
                <div style={{ display: "flex", alignItems: "center", marginBottom: "2%", padding: "1%" }}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                        {icon || (
                            <svg width="48" height="48" xmlns="http://www.w3.org/2000/svg">
                                <g filter="url(#filter2_dii_12621_39177)">
                                    <rect x="0" y="0" width="48" height="48" rx="8" fill="#F4EBFF" stroke="#E4E7EC" />
                                    <path
                                        d="M24 9.5L22.884 7.269C22.563 6.627 22.403 6.306 22.163 6.071C21.952 5.864 21.696 5.706 21.416 5.609C21.099 5.5 20.74 5.5 20.022 5.5H16.2C15.08 5.5 14.52 5.5 14.092 5.718C13.716 5.91 13.41 6.216 13.218 6.592C13 7.02 13 7.58 13 8.7V9.5M13 9.5H28.2C29.88 9.5 30.72 9.5 31.362 9.827C31.926 10.115 32.385 10.574 32.673 11.138C33 11.78 33 12.62 33 14.3V18.7C33 20.38 33 21.22 32.673 21.862C32.385 22.426 31.926 22.885 31.362 23.173C30.72 23.5 29.88 23.5 28.2 23.5H17.8C16.12 23.5 15.28 23.5 14.638 23.173C14.074 22.885 13.615 22.426 13.327 21.862C13 21.22 13 20.38 13 18.7V9.5Z"
                                        fill="none"
                                        stroke="#344054"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        transform="translate(0, 8)"
                                    />
                                </g>
                                <defs>
                                    <filter
                                        id="filter2_dii_12621_39177"
                                        x="-10"
                                        y="-10"
                                        width="68"
                                        height="68"
                                        filterUnits="userSpaceOnUse"
                                    >
                                        <feOffset dx="2" dy="2" result="offset" />
                                        <feGaussianBlur stdDeviation="4" result="blur" />
                                        <feBlend in="SourceGraphic" in2="blur" mode="normal" />
                                    </filter>
                                </defs>
                            </svg>
                        )}
                    </div>
                    <div style={{ marginLeft: "16px" }}>
                        <h2 style={{ fontSize: "20px", margin: 0 }}>{title}</h2>
                        <p style={{ color: "#888" }}>{description}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InfoBanner;
